module.exports = __webpack_public_path__ + "static/media/landing-image.40f5a59c.svg";